<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M4 4.75C3.58579 4.75 3.25 5.08579 3.25 5.5C3.25 5.91421 3.58579 6.25 4 6.25H16C16.4142 6.25 16.75 5.91421 16.75 5.5C16.75 5.08579 16.4142 4.75 16 4.75H4Z" 
    fill="currentColor"/>
    <path d="M14.4393 8.20456C14.3212 7.9288 14.05 7.75 13.75 7.75C13.45 7.75 13.1788 7.9288 13.0607 8.20456L12.0538 10.5538L9.70458 11.5607C9.4288 11.6788 9.25 11.95 9.25 12.25C9.25 12.55 9.4288 12.8212 9.70458 12.9393L12.0538 13.9462L13.0607 16.2954C13.1788 16.5712 13.45 16.75 13.75 16.75C14.05 16.75 14.3212 16.5712 14.4393 16.2954L15.4462 13.9462L17.7954 12.9393C18.0712 12.8212 18.25 12.55 18.25 12.25C18.25 11.95 18.0712 11.6788 17.7954 11.5607L15.4462 10.5538L14.4393 8.20456Z" 
    fill="currentColor"/>
    <path d="M4 9.25C3.58579 9.25 3.25 9.58578 3.25 10C3.25 10.4142 3.58579 10.75 4 10.75H7.75C8.16421 10.75 8.5 10.4142 8.5 10C8.5 9.58578 8.16421 9.25 7.75 9.25H4Z" 
    fill="currentColor"/>
    <path d="M4 13.75C3.58579 13.75 3.25 14.0858 3.25 14.5C3.25 14.9142 3.58579 15.25 4 15.25H6.25C6.66421 15.25 7 14.9142 7 14.5C7 14.0858 6.66421 13.75 6.25 13.75H4Z" 
    fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: 'AIGeneratedTextIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>